import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Ignore known React DOM reconciliation errors (removeChild, insertBefore)
    // These are caused by portal-based UI components (toasts, dropdowns)
    // interfering with React's virtual DOM during re-renders
    const isDomMutationError =
      error?.message?.includes("removeChild") ||
      error?.message?.includes("insertBefore") ||
      error?.message?.includes("not a child");

    if (isDomMutationError) {
      console.warn("React DOM reconciliation error caught and recovered:", error.message);
      // Auto-recover by resetting error state after a tick
      this.setState({ hasError: false });
      return;
    }

    console.error("Unhandled error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
